export const teamsActivities = {
  'Pintou Parceria Suvinil': [
    'Consumidor',
    'Pintor',
    'Quero me formar pintor',
    'Vendedor / Balconista',
    'Arquiteto / Decorador'
  ]
};
